import { CheckoutSelectionState } from "../../state/type";
import {
  CheckoutPaymentMethodSelectionState_ApplePay,
  CheckoutPaymentMethodSelectionState_CreditCard,
  CheckoutPaymentMethodSelectionState_Eps,
  CheckoutPaymentMethodSelectionState_GooglePay,
  CheckoutPaymentMethodSelectionState_Ideal,
} from "../../state/payment-methods";
import { identity } from "fp-ts/es6/function";
import { OpenedPaymentMethod } from "./CheckoutPaymentMethod";

export function mapOpenedPaymentMethodToState(opm: OpenedPaymentMethod): CheckoutSelectionState["paymentMethod"] {
  if (opm === null) {
    return null;
  }

  switch (opm.tag) {
    case "credit-card": {
      if (opm.screen.tag === "input-card-data") {
        return null;
      }

      return identity<CheckoutPaymentMethodSelectionState_CreditCard>(opm.screen.data);
    }

    case "applepay": {
      if (opm.screen.tag === "initialized") {
        return null;
      }

      return identity<CheckoutPaymentMethodSelectionState_ApplePay>({ tag: opm.tag, data: opm.screen.data });
    }

    case "googlepay": {
      return identity<CheckoutPaymentMethodSelectionState_GooglePay>({ tag: opm.tag, data: opm.screen.data });
    }

    case "eps": {
      if (opm.screen.tag === "initialized") {
        return null;
      }

      return identity<CheckoutPaymentMethodSelectionState_Eps>({ tag: opm.tag, data: opm.screen.data });
    }

    case "ideal": {
      if (opm.screen.tag === "initialized") {
        return null;
      }

      return identity<CheckoutPaymentMethodSelectionState_Ideal>({ tag: opm.tag, data: opm.screen.data });
    }

    default: {
      const m: CheckoutSelectionState["paymentMethod"] = { tag: opm.tag };
      return m;
    }
  }
}
